import { render, staticRenderFns } from "./ListAssistantActionComponent.vue?vue&type=template&id=92d13ff2&scoped=true&"
import script from "./ListAssistantActionComponent.vue?vue&type=script&lang=js&"
export * from "./ListAssistantActionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d13ff2",
  null
  
)

export default component.exports